import { BEFORE_ACTIVITY, GET_ACTIVITIES, GET_LEADERBOARD, BEFORE_LEADERBOARD } from '../../redux/types';

const initialState = {
    activities: null,
    activitiesAuth: false,
    leadersboard: null,
    leadersboardAuth: false
}

export default function activityRed(state = initialState, action) {
    switch (action.type) {
        case GET_ACTIVITIES:
            return {
                ...state,
                activities: action.payload,
                activitiesAuth: true
            }
        case BEFORE_ACTIVITY:
            return {
                ...state,
                activities: null,
                activitiesAuth: false
            }
        case GET_LEADERBOARD:
            return {
                ...state,
                leadersboard: action.payload,
                leadersboardAuth: true
            }
        case BEFORE_LEADERBOARD:
            return {
                ...state,
                leadersboard: null,
                leadersboardAuth: false
            }
        default:
            return {
                ...state
            }
    }
}